import * as yup from "yup";

import { IBusinessDetailsSettings } from "../../interfaces-and-types";

export const businessDetailsValidationSchema: yup.SchemaOf<IBusinessDetailsSettings> =
  yup
    .object({
      registered_business_name: yup.string().nullable().required(),
      registered_country: yup.string().nullable().required(),
      registered_business_type_id: yup.string().nullable().required(),
      registration_number: yup
        .string()
        .nullable()
        .optional()
        .when("registered_country", {
          is: (registered_country: string) => registered_country === "NG",
          then: yup.string().required("Registration Number is required"),
        }),
      industry: yup.string().nullable().required(),
      business_email_address: yup.string().nullable().required(),
      business_website: yup.string().nullable().optional(),
      business_terms_and_conditions_url: yup.string().nullable().optional(),
      business_privacy_url: yup.string().nullable().optional(),
      business_description: yup.string().nullable().optional(),
      estimated_monthly_sale_id: yup.string().nullable().required(),

      business_address_line1: yup.string().nullable().required(),
      business_address_line2: yup.string().nullable().optional(),
    })
    .required();
